var React = require('react');

function DoubleArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"currentColor","d":"M1.29 11.385L6.371 6.3a.724.724 0 00.215-.53.751.751 0 00-.215-.53L1.291.16a.737.737 0 00-.48-.165.936.936 0 00-.5.165.713.713 0 00-.265.513.763.763 0 00.165.546l4.538 4.54L.215 10.31a.724.724 0 00-.215.53.751.751 0 00.215.53.759.759 0 001.059 0v.017zm6.04 0L12.411 6.3a.724.724 0 00.215-.525.751.751 0 00-.215-.53L7.347.165A.737.737 0 006.867 0a.936.936 0 00-.5.165.713.713 0 00-.265.513.763.763 0 00.165.546l4.539 4.535-4.535 4.551a.724.724 0 00-.215.53.751.751 0 00.215.53.759.759 0 001.059 0h-.017z","key":1})]);
}

DoubleArrow.defaultProps = {"viewBox":"0 0 12.626 11.584"};

module.exports = DoubleArrow;

DoubleArrow.default = DoubleArrow;
